import { FuseErrorUtilsService } from "./errors";
class QueryValidatorCheckBase {
    queryErrorThrowChecks({ conditionValue, queryType }) {
        throw FuseErrorUtilsService.fuse_helper_createFriendlyError(`Value: ${JSON.stringify(conditionValue)}, is invalid for ${queryType} query`);
    }
    beginWith(conditionValue) {
        if (!(conditionValue && typeof conditionValue === "string")) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$beginsWith" });
        }
    }
    between(conditionValue) {
        if (!(conditionValue && Array.isArray(conditionValue) && conditionValue.length === 2)) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$between" });
        }
    }
    contains(conditionValue) {
        if (!(conditionValue && typeof conditionValue === "string")) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$contains" });
        }
    }
    notContains(conditionValue) {
        if (!(conditionValue && typeof conditionValue === "string")) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$notContains" });
        }
    }
    in_query(conditionValue) {
        if (!(conditionValue && Array.isArray(conditionValue) && conditionValue.length)) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$in" });
        }
    }
    notIn(conditionValue) {
        if (!(conditionValue && Array.isArray(conditionValue) && conditionValue.length)) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$nin" });
        }
    }
    elemMatch(conditionValue) {
        if (!(conditionValue && typeof conditionValue === "object")) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$elemMatch" });
        }
        if (!(conditionValue?.$in?.length && Array.isArray(conditionValue.$in))) {
            throw FuseErrorUtilsService.fuse_helper_createFriendlyError("$elemMatch must have a valid $in query and must be an array of non-zero length");
        }
        for (const item of conditionValue.$in) {
            if (typeof item !== "number" && typeof item !== "string" && typeof item !== "boolean") {
                throw FuseErrorUtilsService.fuse_helper_createFriendlyError("$in in $elemMatch MUST have values of string or number or boolean");
            }
        }
    }
    nestedMatch(conditionValue) {
        if (!(conditionValue && typeof conditionValue === "object")) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$nestedMatch" });
        }
        if (!Object.keys(conditionValue).length) {
            throw FuseErrorUtilsService.fuse_helper_createFriendlyError("$nestedMatch must have a valid query definitions");
        }
    }
    not_query(conditionValue) {
        if (!(conditionValue && typeof conditionValue === "object")) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$not" });
        }
    }
    exists(conditionValue) {
        if (!(String(conditionValue) === "true" || String(conditionValue) === "false")) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$exists" });
        }
    }
    or_query(conditionValue) {
        if (!(conditionValue && Array.isArray(conditionValue) && conditionValue.length)) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$or" });
        }
    }
    and_query(conditionValue) {
        if (!(conditionValue && Array.isArray(conditionValue) && conditionValue.length)) {
            this.queryErrorThrowChecks({ conditionValue, queryType: "$and" });
        }
    }
    throwQueryNotFound(queryType) {
        throw FuseErrorUtilsService.fuse_helper_createFriendlyError(`Query type: ${JSON.stringify(queryType)}, not supported`);
    }
}
export const QueryValidatorCheck = new QueryValidatorCheckBase();
